import { trace } from 'rytm-helpers'
import Controller from './Controller'
import Chart  from 'chart.js/auto'
import { remToPx } from './../shared/affix-fafix'

class SubstrateSidebraController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initCharts()
  }
  addEventListeners() {
    super.addEventListeners()
  }
  removeEventListeners() {
    super.removeEventListeners()
  }

  /**
   * OWN
  */

  getCharts() {
    const container = document.querySelector(this.getContainerSelector())
    return container ? [...container.querySelectorAll(".chart")] : []
  }
  initCharts() {
    const list = this.getCharts()
    list.forEach(this.initChart.bind(this))
  }
  initChart(el, index) {
    const canvas = el.querySelector("canvas");
    const disableAnimation = el.parentNode.dataset.disableAnimation == 'true';
    const list = [...el.querySelectorAll('div[data-value]')]
    if (canvas) {
      let values = []
      let labels = []
      let colors = []
      list.forEach((el) => {
        values.push(el.dataset.value)
        labels.push(el.dataset.label)
        colors.push(el.dataset.color)
      })
      const data = {
        labels: labels,
        datasets: [{
          data: values,
          backgroundColor: colors
        }],
      }
      const options = {
        // rotation: 0,
        // interaction: false,
        // events: [], // disable interactions
        // offset: 0,
        // cutout: remToPx(4.3),
        animation: {
          duration: disableAnimation ? 0 : 3500,
          easing: 'easeOutQuart',
        },
        plugins: {
          legend: {
            display: false,
            // position: 'bottom',
            // align: 'start',
            // labels: {
              
            // }
          },
          tooltip: {
            enabled: true,
            backgroundColor: '#FFFFFF',
            titleColor: '#000000',
            bodyColor: '#000000',
            cornerRadius: 0,
            callbacks: {
              label: (tooltipItem, data) => {
                return tooltipItem.label;
              }
            }
          }
        }
      }
      const config = {
        type: 'doughnut',
        data,
        options
      }
      const chart = new Chart(canvas, config)
    }
  }
  destroyChart(el, index) {
    const canvas = el.querySelector("canvas")
    if (canvas) {
      const chart = Chart.getChart(canvas);
      chart.destroy()
    }
  }

}

export default SubstrateSidebraController;